import { render, staticRenderFns } from "./LottieLoader.vue?vue&type=template&id=0fc222bc&scoped=true"
import script from "./LottieLoader.vue?vue&type=script&lang=js"
export * from "./LottieLoader.vue?vue&type=script&lang=js"
import style0 from "./LottieLoader.vue?vue&type=style&index=0&id=0fc222bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc222bc",
  null
  
)

export default component.exports